type FormatDateDisplay = {
	dateInput: string | Date;
	locale: string;
	mode?: 'display';
};

type FormatDateSort = {
	dateInput: string | Date;
	mode: 'sort';
	locale?: never;
};

type FormatDateArgs = FormatDateDisplay | FormatDateSort;

export const formatDate = ({ dateInput, locale, mode = 'display' }: FormatDateArgs): string => {
	const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

	if (isNaN(date.getTime())) {
		throw new RangeError(`Invalid date input: ${dateInput}`);
	}

	if (mode === 'sort') {
		return date.toISOString().split('T')[0]; // YYYY-MM-DD
	}

	// Custom format for Greenlandic: "decemberip 19-at 2025"
	if (locale === 'kl-gl') {
		const month = new Intl.DateTimeFormat('kl', { month: 'long' }).format(date);
		const day = date.getDate();
		const year = date.getFullYear();
		return `${month} ${day}-at ${year}`;
	}

	return new Intl.DateTimeFormat(locale, {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	}).format(date);
};

type FormatMonth = {
	dateInput: string | Date;
	locale: string;
};

export const formatMonth = ({ dateInput, locale }: FormatMonth): string => {
	const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

	return new Intl.DateTimeFormat(locale, {
		month: 'long',
	}).format(date);
};
